import { connect } from "react-redux";
import { AppState } from "../../store/AppState";
import ProgressIndicator, {
  ProgressIndicatorProps as _ProgressIndicatorProps,
  ProgressIndicatorDOMProps
} from "./progress-indicator-container";
import {
  PickReduxDispatchProps,
  PickReduxStateProps
} from "../../util/typeUtil";
import InProgressUtils from "../../utils/in-progress";

interface ProgressIndicatorProps extends ProgressIndicatorDOMProps {}
// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<
  _ProgressIndicatorProps,
  ProgressIndicatorProps
>;
// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _ProgressIndicatorProps,
  ProgressIndicatorProps
>;
function mapStateToProps(state: AppState): ReduxStateProps {
  return {
    show: InProgressUtils.selectInProgressLength(state)
  };
}
function areStatesEqual(next: AppState, prev: AppState): boolean {
  return InProgressUtils.compareInProgressStates(next, prev);
}
export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  ProgressIndicatorProps,
  AppState
>(mapStateToProps, {}, null, {
  areStatesEqual
})(ProgressIndicator);
